import { render, staticRenderFns } from "./SchemeDetails.vue?vue&type=template&id=2262c29f&scoped=true"
import script from "./SchemeDetails.vue?vue&type=script&lang=ts"
export * from "./SchemeDetails.vue?vue&type=script&lang=ts"
import style0 from "./SchemeDetails.vue?vue&type=style&index=0&id=2262c29f&lang=scss"
import style1 from "./SchemeDetails.vue?vue&type=style&index=1&id=2262c29f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262c29f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2262c29f')) {
      api.createRecord('2262c29f', component.options)
    } else {
      api.reload('2262c29f', component.options)
    }
    module.hot.accept("./SchemeDetails.vue?vue&type=template&id=2262c29f&scoped=true", function () {
      api.rerender('2262c29f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schemes/components/SchemeDetails.vue"
export default component.exports